import React from 'react';
import CategoryRow from '../CategoryRow';

const Clothing = () => (
  <CategoryRow title="Clothing" category="Clothing" exploreTo="/all-clothing-item" />
);

export default Clothing;
